import nxModule from 'nxModule';
import internetCheckService from '../../../../react/system/internetCheckService';

nxModule.factory('internetCheckService', () => internetCheckService);
